import React from 'react'
import { FormControl, Button, Grid, Typography } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle, UploadCloud, XCircle } from 'react-feather'

import { FileManagerInput, LinearLoading } from 'common'

import { FilesTable } from './FilesTable'


const acceptConfiguration = {
    'application/pdf': []
}

export const FileMaganerSection = ({ useFetchInit }) => {

    const { 
        //------------- Generales
        location,
        paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

    // ------------------------------------------------ Generales
        
    // ------------------------------------------------ globalStates
    const {formOpeningMode} = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormRequestGlobal } = Forms
    const { formState, onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange } = FormRequestGlobal
    
    // ------------------------------------------------ FetchData
    const { fetchAllFiles } = FetchData
    const { loadingFetchInfoFiles } = fetchAllFiles
    
    // ------------------------------------------------ Actions
    const { onSubmitFormFiles, handleClickCleanUpFiles } = Actions
    
    return ( 
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Archivos adjuntos
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 3}}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                    {/* <form onSubmit={onSubmitFormFiles}> */}
                        <div className="text-center">
                            {(formState.idgestion>0) && (
                                <>
                                    <Button
                                        startIcon= {<UploadCloud/>}
                                        variant="contained"
                                        type="button"
                                        className='btn-round'
                                        color='primary'
                                        sx={{ marginRight: 3, marginLeft: 1 }}
                                        onClick={onSubmitFormFiles}
                                        disabled={ (formOpeningMode === 'READONLY') ? true : false }
                                    >
                                        Subir
                                    </Button>
                                </>
                            )}
                            <Button
                                startIcon={<XCircle/>}
                                variant="contained"
                                type="button"
                                className='btn-round'
                                color='error'
                                onClick={handleClickCleanUpFiles}
                                sx={{ marginRight: 3, marginLeft: 1 }}
                                disabled={ (formOpeningMode === 'READONLY') ? true : false }
                            >
                                Limpiar
                            </Button>
                        </div>
                        <div className="pt-2"></div>
                        <FormControl fullWidth>
                            <label htmlFor="attachmentt"> * Documentos para enviar a revisión </label>
                            {formOpeningMode !== 'READONLY' && (
                                <FileManagerInput
                                    // datos (listados, individuales)
                                    acceptedFiles={formState.acceptedFiles}
                                    fileRejections={formState.fileRejections}
                                    NameId='attachmentt'
                                    typeFiles='PDF'
                                    maxFiles={4}
                                    accept={acceptConfiguration}

                                    // HandleClicks

                                    // Funciones
                                    setAcceptedFiles={onDropZoneAcceptedFilesChange}
                                    setFileRejections={onDropZoneRejectionsFilesChange}
                                />
                            )}
                        </FormControl>
                    {/* </form> */}
                </Grid>
                <Grid item xs={12} sm={12} md={8} lg={8} sx={{ mb: 2 }}>
                {loadingFetchInfoFiles && ( <LinearLoading /> )}
                    <FilesTable
                        useFetchInit = {useFetchInit}
                    />
                </Grid>
            </Grid>
            <div className="border-bottom border-secondary m-3"></div>
        </>
    )
}
